module.exports = __webpack_public_path__ + "img/align-right.4a078f9e.svg";